import React from 'react';
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

const MultipleShowCategories = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'categories.multi.show',
        text: 'Do you want to show selected categories?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple show categories" >
      <FontAwesomeIcon
        rotation={180}
        color={'blue'}
        size={'lg'}
        icon={solid('eye')}/>
    </button>
  );
};

export default MultipleShowCategories;
